import moment from 'moment';
import {
    EBFL1RecordCode,
    EBFL1RecordState,
    TBFL1CommonData,
    TBFL1CommonFields,
} from '../@types';
import { EMARPOLDocuments } from '../../marpol/@types';

export type TBFL1AItem1 =
    | {
          place: 'PORT';
          portName: string;
      }
    | {
          place: 'AT_SEA';
          startPosition: {
              latitude: string;
              longitude: string;
          };
          stopPosition: {
              latitude: string;
              longitude: string;
          };
      };

export type TBFL1AItem2 = {
    remarks: string;
};
export type TBFL1AItem3 = {
    remarks: string;
};
export type TBFL1AItem4 = {
    remarks: string;
};
export type TBFL1AItem5 = {
    remarks: string;
};
export type TBFL1AItem6 = {
    remarks: string;
};
export type TBFL1AItem7 = {
    remarks: string;
};
export type TBFL1AItem8 = {
    remarks: string;
};

export type TBFL1A1 = TBFL1CommonFields &
    TBFL1CommonData & {
        recordCode: EBFL1RecordCode.BFL1A1;
        item1: TBFL1AItem1;
        item2: TBFL1AItem2;
        item3: TBFL1AItem3;
        item4: TBFL1AItem4;
        item5: TBFL1AItem5;
        item6: TBFL1AItem6;
        item7: TBFL1AItem7;
        item8: TBFL1AItem8;
    };

export type TBFL1GroupA = TBFL1A1;

const BFL1_GROUPA_DEFAULTS: {
    A1: TBFL1A1;
} = {
    A1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL1,
        state: EBFL1RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            place: 'AT_SEA',
            startPosition: {
                latitude: '',
                longitude: '',
            },
            stopPosition: {
                latitude: '',
                longitude: '',
            },
        },
        item2: { remarks: '' },
        item3: { remarks: '' },
        item4: { remarks: '' },
        item5: { remarks: '' },
        item6: { remarks: '' },
        item7: { remarks: '' },
        item8: { remarks: '' },
        recordCode: EBFL1RecordCode.BFL1A1,
        processedTanks: [],
    },
};

export { BFL1_GROUPA_DEFAULTS };
